define.alias("shared/components/shared/ui/social-set-switcher/list", "calendar/components/shared/ui/social-set-switcher/list");